import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ProjectLayout } from '@/components/layout/ProjectLayout'
import { ProjectTeamTab } from '@/components/projects/ProjectTeamTab'
import { UsageDashboard } from '@/components/usage/UsageDashboard'
import { useAuth } from '@/contexts/AuthContext'
import { supabase } from '@/lib/supabase'
import { Loader2 } from 'lucide-react'

export function ProjectTeamPage() {
  const { id } = useParams<{ id: string }>()
  const { user } = useAuth()
  const [projectOwnerId, setProjectOwnerId] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadProjectOwner()
  }, [id])

  const loadProjectOwner = async () => {
    if (!id) return

    try {
      const { data, error } = await supabase
        .from('projects')
        .select('owner_user_id')
        .eq('id', id)
        .maybeSingle()

      if (error) {
        throw error
      }

      if (!data) {
        throw new Error('Project not found')
      }

      setProjectOwnerId(data.owner_user_id)
    } catch (error) {
      console.error('Error loading project:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <ProjectLayout>
        <div className="flex justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      </ProjectLayout>
    )
  }

  if (!id || !projectOwnerId) {
    return (
      <ProjectLayout>
        <div className="text-center py-12 text-muted-foreground">
          Project not found
        </div>
      </ProjectLayout>
    )
  }

  return (
    <ProjectLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-semibold tracking-tight">Team</h1>
          <p className="mt-2 text-muted-foreground">
            Manage team members and their access to this project
          </p>
        </div>

        <ProjectTeamTab projectId={id} projectOwnerId={projectOwnerId} />

        {user?.id === projectOwnerId && (
          <div className="border rounded-lg p-6 space-y-4">
            <div>
              <h2 className="text-lg font-semibold">Usage & Limits</h2>
              <p className="text-sm text-muted-foreground">
                Your current plan usage across all projects
              </p>
            </div>
            <UsageDashboard />
          </div>
        )}
      </div>
    </ProjectLayout>
  )
}
